import { BookmarksItem } from "ui-components";
import { StateCreator } from "zustand";

import { RootStore } from "./";

export interface BookmarksState {
	bookmarksList: BookmarksItem[];
}

export type BookmarksStore = BookmarksState;

export const createBookmarksSlice: StateCreator<
	RootStore,
	[],
	[],
	BookmarksStore
> = () => ({
	bookmarksList: MOCK_BOOKMARKS,
});

const MOCK_BOOKMARKS: BookmarksItem[] = [
	{
		id: "bookmark-1",
		title: "Full country view",
		type: "feature",
		description: "This is a bookmark",
		isShared: true,
	},
	{
		id: "bookmark-2",
		title: "Coconico County, Arizona",
		type: "place",
	},
	{
		id: "bookmark-3",
		title: "Temporary sketch",
		type: "sketch",
		description: "Proposed feature",
		isShared: true,
	},
];
